import * as React from 'react';
export const githubSvg = React.forwardRef(function githubSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      style: {
        fill: 'light-dark(#000,#fff)',
      },
      d: 'M14.148 20.812c-3.093-.372-5.273-2.574-5.273-5.427 0-1.159.422-2.411 1.125-3.246-.305-.765-.258-2.388.094-3.06.937-.117 2.203.37 2.953 1.043.89-.279 1.828-.418 2.976-.418 1.149 0 2.086.14 2.93.394.727-.649 2.016-1.136 2.953-1.02.328.626.375 2.25.07 3.038.75.881 1.149 2.064 1.149 3.27 0 2.852-2.18 5.008-5.32 5.402.797.51 1.336 1.624 1.336 2.899v2.412c0 .695.586 1.09 1.289.811 4.242-1.6 7.57-5.797 7.57-10.991C28 9.356 22.61 4 15.977 4S4 9.356 4 15.919c0 5.148 3.305 9.414 7.758 11.014.633.232 1.242-.185 1.242-.811v-1.855c-.328.139-.75.232-1.125.232-1.547 0-2.46-.835-3.117-2.389-.258-.626-.54-.997-1.078-1.067-.282-.023-.375-.139-.375-.278 0-.278.468-.487.937-.487.68 0 1.266.418 1.875 1.276.469.672.961.973 1.547.973s.961-.208 1.5-.742c.399-.394.703-.742.984-.974',
    }),
  );
});
githubSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var github = {
  category: 'brand',
  colorable: false,
  name: 'github',
  svg: githubSvg,
};
